import {
  IS_NETWORK_CONNECTED,
  SHOW_APPLE_INSTALLATION_INFO,
  REHYDRATE_WITH_SESSION_STORAGE,
  SET_PRIVACY_ACCEPTED,
  FETCH_OSPEDALI,
  FETCH_OSPEDALI_SUCCESS,
} from "./index";

export const changeNetworkConnection = (isConnected) => ({
  type: IS_NETWORK_CONNECTED,
  isConnected,
});

export const showAppleInstallationInfo = (value) => ({
  type: SHOW_APPLE_INSTALLATION_INFO,
  value,
});

export const rehydrateWithSessionStorage = (sessionStorageValues) => ({
  type: REHYDRATE_WITH_SESSION_STORAGE,
  sessionStorageValues,
});

export const setPrivacyAccepted = (value) => ({
  type: SET_PRIVACY_ACCEPTED,
  value,
});

export const fetchOspedali = () => ({
  type: FETCH_OSPEDALI,
});

export const fetchOspedaliSuccess = (ospedali) => ({
  type: FETCH_OSPEDALI_SUCCESS,
  ospedali,
});
